

import { useContext, useEffect, useState } from 'react'


import 'bootstrap-daterangepicker/daterangepicker.css';

import { useLocation, useNavigate } from 'react-router-dom';
import { LoyaltyContext } from '../../../context/loyalty/LoyaltyContext';
import { useForm } from '../../../components/hooks/useForm';
import Message from '../../../components/ui/Message';




export const SearchLoyaltyClientPage = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const [isFormValid, setIsFormValid] = useState(false);
    const { addClient, searchClient } = useContext(LoyaltyContext);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [services, setServices] = useState([]);
    const [client, setClient] = useState(null);

    var supplier;

    if (state) {
        supplier = state.supplier;
    } else {
        supplier = {
            name: '',
            correo: '',
            plataforma: ''
        }
    }


    const { formState, onInputChange } = useForm(supplier);

    const { name, correo, plataforma } = formState

    const handleNew = () => {
        navigate("/loyalty/clients/client");
    }



    const handleSearch = async () => {

        const formValid = correo.length > 0
        if (!formValid) {
            setErrorMessage("Debe completar los campos requeridos.");
            return false;
        }

        var resp = await searchClient(correo);
        if (resp != null) {
            navigate("/loyalty/clients/client/info", { state: { client: resp } });

        } else {
            setErrorMessage("Ocurrió un error por favor intente de nuevo.");
        }
    }

    const removeError = () => {
        setErrorMessage('');
    }

    const removeSucessMessage = () => {
        setSuccessMessage('');
        navigate(-1);
    }

    return (
        <>
            <div className='container d-flex align-items-center justify-content-center mt-5' style={styles.container}>


                <div className='col-md-6 row '>
                    <div className="d-flex justify-content-between align-items-center  mb-1 mb-md-0">
                        <h3>Buscar cliente</h3>
                        <button
                            type="button"
                            onClick={() => handleNew()}
                            className="btn btn-success">
                            Crear cliente
                        </button>
                    </div>
                    <hr />

                    <form className="row g-3 " >



                        <div className="mb-3">
                            <label htmlFor="correoInput" className="form-label">Correo *</label>
                            <input
                                id='correoInput'
                                type="text"
                                className={`form-control ${correo ? 'is-valid' : 'is-invalid'}`}
                                placeholder="Correo"
                                name="correo"
                                value={correo}
                                onChange={onInputChange}
                                required
                            />
                        </div>






                        <div className='container d-flex align-items-center justify-content-center mt-5'>

                            <button type="button" onClick={handleSearch} className="btn btn-primary ms-5" >Buscar</button>
                        </div>
                    </form>
                    <div style={{ height: '100px' }}></div>
                </div>

                {
                    errorMessage.length > 0 ? <Message type='error' message={errorMessage} closeDialog={removeError} handleOk={removeError} backgroundColor='rgba(0,0,0,0.4)' /> : ''
                }
                {
                    successMessage.length > 0 ? <Message type='success' message={successMessage} title='Exitoso' closeDialog={removeSucessMessage} handleOk={removeSucessMessage} backgroundColor='rgba(0,0,0,0.4)' /> : ''
                }



            </div>

        </>
    )
}


const styles = {
    container: {
        flex: 1,
        marginTop: 10,
        marginHorizontal: 20
    }
};
